var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M18.188 14.25h-1.125a.563.563 0 00-.563.562v3.938H5.25V7.5h5.063c.31 0 .562-.252.562-.563V5.812a.562.562 0 00-.562-.562H4.688C3.756 5.25 3 6.006 3 6.937v12.375C3 20.244 3.756 21 4.688 21h12.375c.931 0 1.687-.756 1.687-1.688v-4.5a.562.562 0 00-.562-.562zM19.688 3h-5.579a.984.984 0 00-.984.984v.658a.984.984 0 001.012.956l2.363-.067-8.752 8.687-.002.002a.843.843 0 000 1.193l.842.839.002.002a.844.844 0 001.192-.003L18.469 7.5l-.066 2.363v.028c0 .543.44.984.984.984h.629c.543 0 .984-.44.984-.984V4.312C21 3.588 20.412 3 19.688 3z"
  }))));
}

export default SvgExternalLink;